import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { ApiPartnerService } from "../../api/api-partner.service";
import { ActivatedRoute, Router, ParamMap } from "@angular/router";
import { FormGroup, FormControl, FormBuilder, NgForm } from "@angular/forms";
// import { FormControl} from '@angular/forms';
import { LoadJsService } from "../../load-js/load-js.service";
import { URLSearchParams } from "@angular/http";
import { AuthenticationService } from "@app/_services/authentication.service";
import swal from "sweetalert/dist/sweetalert.min.js";

@Component({
  selector: "app-listpackagenextsys",
  templateUrl: "./listpackagenextsys.component.html",
  styleUrls: ["./listpackagenextsys.component.css"],
})
export class ListpackagenextsysComponent implements OnInit {
  @ViewChild('closeBtn', { static: false }) closeBtn!: ElementRef<HTMLButtonElement>;
  textSearch = new FormControl("");
  packageList: any = {};
  availableStbList: any = {};
  paging: any = {};

  formSet = this.fb.group({
    customerId: [""],
    tokenCode: [""],
    sn: [""],
  });

  msearch: string;
  //paging_link : any = [];
  page_self = [];
  page_next = [];
  page_prev = [];
  meta = [];
  last_index: number;
  first_index: number;
  total_count: number;
  querySearch = false;
  searching = false;
  dataempty = true;
  currentParams = {};
  queryParams = "";
  searchQueryParams = "";
  href = "";
  alert_act = "";
  alert_actmsg = "";

  alert_failed = false;
  alert_success = false;

  table_load = false;
  table_data = false;
  currentUser: any;
  isLoading: boolean = false;

  constructor(
    public partnerService: ApiPartnerService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    public LoadJsOrder: LoadJsService,
    private router: Router,
    private Auth: AuthenticationService
  ) { }

  ngOnInit() {
    this.currentUser = this.Auth.currentUserValue;
    this.loadStart();
  }

  loadStart() {
    this.route.queryParams
      .subscribe((params) => {
        if (params.search != "" && params.search != undefined) {
          this.msearch = params.search;
          this.querySearch = true;

          this.currentParams = params;
          this.queryParams = "?" + this.queryStr(params);
          this.loadPackage(this.queryParams);
        } else {
          this.querySearch = false;
          this.currentParams = params;

          this.queryParams = "?" + this.queryStr(params);
          this.loadPackage(this.queryParams);
        }
      });

    this.loadAvailableSTB("?paired=false");
  }

  refreshPage() {
    this.ngOnInit();
  }

  queryStr(options: any) {
    let params = new URLSearchParams();
    for (let key in options) {
      params.set(key, options[key]);
    }
    return params.toString();
  }

  // Issues list
  loadPackage(params: any) {
    this.table_load = true;
    return this.partnerService
      .GetNextsysPartnerPackages(params)
      .subscribe((output: any) => {
        console.log(output);
        this.packageList = output.data;

        this.table_load = false;

        // start pagination
        this.paging = output.pagex;
        this.page_self = output.pagex.self;
        this.page_next = output.pagex.next;
        this.page_prev = output.pagex.prev;
        this.meta = output.meta;
        this.total_count = this.meta["totalCount"];
        let self = this.page_self["page"];
        if (self * this.meta["perPage"] < this.meta["totalCount"]) {
          this.last_index = self * this.meta["perPage"];
        } else {
          this.last_index = this.meta["totalCount"];
        }

        this.first_index = (self - 1) * this.meta["perPage"] + 1;
        //end pagination
      });
  }

  loadAvailableSTB(params: any) {
    return this.partnerService
      .GetListpartnernextsysstb(params)
      .subscribe((output: any) => {
        console.log(output);
        this.availableStbList = output.data;
      });
  }

  search() {
    this.querySearch = true;
    this.searchQueryParams = this.queryParams + "&search=" + this.msearch;
    this.loadPackage(this.searchQueryParams);
  }

  queryStrSearch() {
    if (this.msearch) {
      return "&search=" + this.msearch;
    } else {
      return "";
    }
  }

  clearForm() {
    this.formSet.reset();
    this.formSet.get("tokenCode").setValue(undefined);
    this.formSet.get("sn").setValue(undefined);
  }

  onActionClick(act: any, item: any) {
    this.alert_act = act;
    if (this.alert_act == "pair") {
      this.clearForm();
      this.formSet.get('customerId').setValue(item.customerid);
    }
    if (this.alert_act == "unpair") {
      this.formSet.get('customerId').setValue(item.customerid);
      this.formSet.get('sn').setValue(item.pairedstbsn);
      this.submitUnPair();
    }
  }

  private closeModal(): void {
    this.closeBtn.nativeElement.click();
  }

  alertsx(message: any) {
    swal({
      title: "Sukses!",
      text: message,
      icon: "success",
      buttons: false,
      timer: 1000,
    }).then(() => {
      this.ngOnInit();
    });
  }
  alertfx(message: any) {
    swal({
      title: "Gagal!",
      text: message,
      icon: "error",
    });
  }

  submitPair() {
    // SweetAlert Konfirmasi
    swal({
      title: "Konfirmasi",
      text: "Apakah Anda yakin ingin melanjutkan?",
      icon: "warning",
      buttons: ["Batal", "Ya, Lanjutkan"],
      dangerMode: true,
    }).then((willSubmit) => {
      if (willSubmit) {
        this.closeModal();

        this.isLoading = true;
        let postData = {
          "customerid": this.formSet.get('customerId').value,
          "sn": this.formSet.get('sn').value,
          "token": this.formSet.get('tokenCode').value
        }
        // Jika pengguna mengkonfirmasi, jalankan aksi
        this.partnerService.PostSubmitNextsysPairing(postData).subscribe(
          (output: any) => {
            if (output) {
              this.isLoading = false;
              console.log(output);
              if (output.data.status === true) {
                this.alertsx(output.status.message)
              } else {
                this.alertfx(output.status.message)
              }
            } else {
              swal({
                title: "Error",
                text: "Error hit API",
                icon: "error",
              });
            }
          },
          (error) => {
            this.isLoading = false;
            console.error("Error:", error);
            swal({
              title: "Error",
              text: "An error occurred while calling the API.",
              icon: "error",
            });
          }
        );
      } else {
        // Jika pengguna membatalkan aksi
        swal({
          title: "Dibatalkan",
          text: "Aksi dibatalkan.",
          icon: "info",
        });
      }
    });
  }

  submitUnPair() {
    // SweetAlert Konfirmasi
    swal({
      title: "Konfirmasi",
      text: "Apakah Anda yakin ingin melanjutkan?",
      icon: "warning",
      buttons: ["Batal", "Ya, Lanjutkan"],
      dangerMode: true,
    }).then((willSubmit) => {
      if (willSubmit) {
        this.isLoading = true;
        let postData = {
          "customerid": this.formSet.get('customerId').value,
          "sn": this.formSet.get('sn').value,
        }
        // Jika pengguna mengkonfirmasi, jalankan aksi
        this.partnerService.PostSubmitNextsysUnPairing(postData).subscribe(
          (output: any) => {
            if (output) {
              this.isLoading = false;
              console.log(output);
              if (output.data.status === true) {
                this.alertsx(output.status.message)
              } else {
                this.alertfx(output.status.message)
              }
            } else {
              swal({
                title: "Error",
                text: "Error hit API",
                icon: "error",
              });
            }
          },
          (error) => {
            this.isLoading = false;
            console.error("Error:", error);
            swal({
              title: "Error",
              text: "An error occurred while calling the API.",
              icon: "error",
            });
          }
        );
      } else {
        // Jika pengguna membatalkan aksi
        swal({
          title: "Dibatalkan",
          text: "Aksi dibatalkan.",
          icon: "info",
        });
      }
    });
  }
}
